import React, { useState } from 'react';
import Modal from './Modal';
import BottomSheet from './BottomSheet';

import { useWindowSize } from '../CommonHooks';

export default function PopUpLayer({ children, isOpen, bottomSheetAttribute, ...rest }) {
    const { isMobileSize } = useWindowSize();

    if (isOpen === false) {
        return null;
    }
    if (isMobileSize) {
        return (
            <BottomSheet {...bottomSheetAttribute} isOpen={isOpen} {...rest}>
                {children}
            </BottomSheet>
        );
    } else {
        return (
            <Modal isOpen={isOpen} {...rest}>
                {children}
            </Modal>
        );
    }
}
